module.exports = __webpack_public_path__ + "img/symbol_9.f61e2a15.png";